import React from 'react'

function Presentation(){
    return(
        <div id='presentation'>
            <h1>UI PRESENTATAION</h1>
            <p> Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt minus dolor 
                dolores </p>
        </div>
    )
}
  export default Presentation;
